module.exports = __webpack_public_path__ + "static/VectrexWeb-Bold-df59f725a66612608e69a491646d7232.woff2";